/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { qualificationIdGet } from '../fn/qualification/qualification-id-get';
import { QualificationIdGet$Params } from '../fn/qualification/qualification-id-get';
import { QualificationModel } from '../models/qualification-model';
import { QualificationModelSearchResultModel } from '../models/qualification-model-search-result-model';
import { qualificationPost } from '../fn/qualification/qualification-post';
import { QualificationPost$Params } from '../fn/qualification/qualification-post';
import { qualificationSearchQualificationPost } from '../fn/qualification/qualification-search-qualification-post';
import { QualificationSearchQualificationPost$Params } from '../fn/qualification/qualification-search-qualification-post';

@Injectable({ providedIn: 'root' })
export class MDIQualificationService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `qualificationSearchQualificationPost()` */
  static readonly QualificationSearchQualificationPostPath = '/Qualification/SearchQualification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qualificationSearchQualificationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  qualificationSearchQualificationPost$Response(params?: QualificationSearchQualificationPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<QualificationModelSearchResultModel>> {
    return qualificationSearchQualificationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qualificationSearchQualificationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  qualificationSearchQualificationPost(params?: QualificationSearchQualificationPost$Params, context?: HttpContext): Observable<QualificationModelSearchResultModel> {
    return this.qualificationSearchQualificationPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<QualificationModelSearchResultModel>): QualificationModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `qualificationIdGet()` */
  static readonly QualificationIdGetPath = '/Qualification/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qualificationIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  qualificationIdGet$Response(params: QualificationIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<QualificationModel>> {
    return qualificationIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qualificationIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  qualificationIdGet(params: QualificationIdGet$Params, context?: HttpContext): Observable<QualificationModel> {
    return this.qualificationIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<QualificationModel>): QualificationModel => r.body)
    );
  }

  /** Path part for operation `qualificationPost()` */
  static readonly QualificationPostPath = '/Qualification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qualificationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  qualificationPost$Response(params?: QualificationPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return qualificationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qualificationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  qualificationPost(params?: QualificationPost$Params, context?: HttpContext): Observable<string> {
    return this.qualificationPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
